import crypto from 'crypto';

import Const from 'src/config/Const';

const decrypt = (text: string): string => {
  const algorithm = 'aes-256-cbc';
  const cipher = crypto.createDecipheriv(
    algorithm,
    Const.cryptoKey || '',
    Const.cryptoIvKey || ''
  );
  let crypted = cipher.update(text, 'base64', 'utf-8');
  crypted += cipher.final('utf-8');
  return crypted;
};

export default decrypt;
